var _path, _path2, _path3, _g, _path4, _path5, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUfo32(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1070,
    height: 1311,
    viewBox: "0 0 1070 1311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M567.353 785.714C650.994 810.22 720.541 853.144 765.392 902.631C810.269 952.147 830.209 1007.95 815.419 1058.44C800.628 1108.92 753.725 1145.14 689.223 1162.61C624.758 1180.07 543.043 1178.68 459.402 1154.17C375.761 1129.67 306.214 1086.74 261.363 1037.26C216.486 987.742 196.546 931.937 211.337 881.453C226.127 830.969 273.029 794.747 337.532 777.277C401.997 759.817 483.712 761.209 567.353 785.714Z",
    fill: "url(#paint0_radial_1794_3844)",
    stroke: "#00FF26",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M790.107 260.356C785.127 229.303 765.254 198.071 735.302 182.253C685.753 156.087 621.804 174.976 594.198 223.251C629.561 227.494 669.479 232.817 702.829 239.302C731.673 244.911 762.28 253.768 790.107 260.356Z",
    fill: "url(#paint1_linear_1794_3844)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M734.368 184.022C762.753 199.012 781.962 228.197 787.609 257.702C760.708 251.228 731.066 242.756 703.211 237.339C670.741 231.025 632.089 225.816 597.482 221.633C625.338 176.226 686.681 158.838 734.368 184.022Z",
    stroke: "url(#paint2_linear_1794_3844)",
    strokeOpacity: 0.54,
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1794_3844)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M673.37 368.607C778.649 389.08 907.645 354.602 914.929 317.144C922.213 279.686 804.059 248.787 698.78 228.314C593.5 207.842 451.792 194.939 444.508 232.397C437.224 269.855 568.09 348.135 673.37 368.607ZM738.563 328.602C736.751 337.937 708.631 340.333 675.755 333.952C642.879 327.571 617.697 314.831 619.509 305.496C621.32 296.161 649.44 293.766 682.316 300.146C715.192 306.527 740.374 319.267 738.563 328.602Z",
    fill: "url(#paint3_radial_1794_3844)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M698.493 229.787C751.118 240.02 806.884 252.846 848.559 267.772C869.411 275.24 886.628 283.196 898.152 291.555C909.756 299.971 915.098 308.415 913.456 316.858C912.621 321.155 910.012 325.537 905.709 329.896C901.41 334.251 895.491 338.509 888.19 342.555C873.588 350.646 853.633 357.787 830.559 363.138C784.41 373.841 726.056 377.324 673.656 367.135C621.217 356.938 562.342 332.324 517.496 305.583C495.071 292.213 476.221 278.349 463.452 265.544C457.066 259.14 452.248 253.047 449.255 247.456C446.256 241.855 445.161 236.898 445.981 232.683C446.794 228.502 449.491 224.914 454.041 221.874C458.61 218.821 464.961 216.385 472.849 214.537C488.619 210.842 510.157 209.581 534.862 210.131C584.245 211.232 645.901 219.56 698.493 229.787ZM682.601 298.673C666.067 295.464 650.675 294.45 639.136 295.433C633.377 295.924 628.489 296.919 624.88 298.443C621.331 299.942 618.634 302.125 618.036 305.21C617.437 308.296 619.121 311.329 621.852 314.046C624.629 316.81 628.79 319.561 633.947 322.171C644.281 327.399 658.935 332.214 675.469 335.423C692.003 338.632 707.396 339.648 718.936 338.666C724.694 338.175 729.582 337.18 733.191 335.656C736.74 334.157 739.437 331.974 740.035 328.888C740.634 325.803 738.951 322.769 736.22 320.051C733.442 317.288 729.281 314.537 724.124 311.928C713.79 306.7 699.135 301.882 682.601 298.673Z",
    stroke: "url(#paint4_linear_1794_3844)",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M634.771 310.5L648.57 307.862C669.312 303.897 690.786 307.11 709.46 316.971L725.73 325.563L672.07 1021.41L660.596 1030.49C556.145 1113.14 401.412 1068.94 356.369 943.599L634.771 310.5Z",
    fill: "#005B0F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_f_1794_3844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M649.46 307.213C667.373 302.579 686.376 304.895 702.652 313.696L713.522 319.573L638.054 951.218C634.84 978.119 613.788 999.413 586.925 1002.94L577.599 1004.16C527.127 1010.77 476.167 996.192 436.835 963.878C419.213 949.4 412.828 925.273 420.983 903.975L649.46 307.213Z",
    fill: "#1DAD35"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18,
    filter: "url(#filter2_f_1794_3844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M668.252 308.526C676.471 306.036 685.343 306.937 692.894 311.028L697.315 313.423L603.189 873.426C564.839 909.942 501.259 887.316 494.598 834.783L494.337 832.728L668.252 308.526Z",
    fill: "#5BE472"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1794_3844",
    x: 444.217,
    y: 208.508,
    width: 471.032,
    height: 170.21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1794_3844"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1794_3844",
    x: 408.576,
    y: 295.978,
    width: 313.846,
    height: 718.642,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.45,
    result: "effect1_foregroundBlur_1794_3844"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1794_3844",
    x: 485.437,
    y: 298.245,
    width: 220.778,
    height: 601.968,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.45,
    result: "effect1_foregroundBlur_1794_3844"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1794_3844",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.378 969.944) rotate(106.329) scale(193.974 316.737)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.275629,
    stopColor: "#3CAB55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1794_3844",
    x1: 695.158,
    y1: 188.369,
    x2: 685.966,
    y2: 261.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A445A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A92C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1794_3844",
    x1: 670.363,
    y1: 136.325,
    x2: 691.449,
    y2: 240.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1794_3844",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(680.865 318.398) rotate(12.1715) scale(214.014 89.7414)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A7DC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#302A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1794_3844",
    x1: 696.818,
    y1: 202.709,
    x2: 683.088,
    y2: 318.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54FF39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUfo32);
export default __webpack_public_path__ + "static/media/ufo32.07d9574f906cae50b924de7fe1530efb.svg";
export { ForwardRef as ReactComponent };